import { useSelector } from 'react-redux';
import {
  resourcesState,
  selectGetInfiniteResourcesStatus,
  selectGetResourcesLoadingStatus,
} from 'store/resources/selectors';
import { bookingsState } from 'store/bookings/selectors';
import { useGetCurrentLocationResourcesTypesQuery } from 'store/resources/hooks';
import { ACTION_STATUSES } from 'shared/consts';

export const useResourceLoadingHandler = (isFilteringEnabled: boolean): boolean => {
  const isResourcesLoading = useSelector(selectGetResourcesLoadingStatus);
  const { status } = useSelector(selectGetInfiniteResourcesStatus);
  const {
    isLoading: isResourceTypesLoading,
    isFetching: isResourceTypesFetching,
    isSuccess: isResourceTypesSuccess,
    isError: isResourceTypesError,
  } = useGetCurrentLocationResourcesTypesQuery();

  const { loading: isUpcomingBookingLoading } = useSelector(bookingsState);
  const resourcesStat = useSelector(resourcesState);
  const isInfiniteResourcesLoading = status === ACTION_STATUSES.PENDING;
  const isInfiniteResourcesResolved = status === ACTION_STATUSES.FULFILLED || status === ACTION_STATUSES.REJECTED;
  const isRegularResourcesResolved =
    !isResourcesLoading && (resourcesStat.resources !== null || Boolean(resourcesStat.error));
  const isResourcesFetchResolved = status === null ? isRegularResourcesResolved : isInfiniteResourcesResolved;
  const isResourceTypesPending =
    isFilteringEnabled &&
    (isResourceTypesLoading || isResourceTypesFetching) &&
    !isResourceTypesSuccess &&
    !isResourceTypesError;

  const isLoadingState =
    isResourcesLoading || isResourceTypesPending || isUpcomingBookingLoading || isInfiniteResourcesLoading;

  return isLoadingState || !isResourcesFetchResolved;
};
